'use strict';

var psrDirectives = angular.module('psrApp.directives', ['custom_directives']);

psrDirectives.directive('navigationHeader', ['$templateCache', function ($templateCache) {
	return {
		restrict: 'E',
		templateUrl: 'navigation-header.html',
		controller: 'NavigationHeaderCtrl'
	};
}]);

psrDirectives.directive('freeServicesHighlight', ['$templateCache', '$rootScope', function ($templateCache, $rootScope) {
	return {
		restrict: 'E',
		templateUrl: $rootScope.getTemplateVersion('free-services-highlight'),
		controller: function( $scope, $element ){
			$scope.selected = 0;
	    	$scope.setSelected= function(value){
	      		$scope.selected=value;
	    	};
		}
	};
}]);

psrDirectives.directive('articlesHighlight', ['$templateCache', function ($templateCache) {
	return {
		restrict: 'E',
		templateUrl: 'articles-highlight.html'
	};
}]);

psrDirectives.directive('servicesHighlight', ['$templateCache', function ($templateCache) {
	return {
		restrict: 'E',
		templateUrl: 'services-highlight.html'
	};
}]);

psrDirectives.directive('coursesHighlight', ['$templateCache', function ($templateCache) {
    return {
        restrict: 'E',
        templateUrl: 'courses-highlight.html'
    };
}]);

psrDirectives.directive('shoppingHighlight', ['$templateCache', function ($templateCache) {
	return {
		restrict: 'E',
		templateUrl: 'shopping-highlight.html'
	};
}]);

psrDirectives.directive('mainHighlight', ['$templateCache', function ($templateCache) {
	return {
		restrict: 'E',
		templateUrl: 'main-highlight.html'
	};
}]);

psrDirectives.directive('forumHighlight', ['$templateCache', function ($templateCache) {
	return {
		restrict: 'E',
		templateUrl: 'forum-highlight.html'
	};
}]);

psrDirectives.directive('channelHighlight', ['$templateCache', function ($templateCache) {
	return {
		restrict: 'E',
		scope: {
			customTemplate: '=customTemplate',
			channel: '&channel',
		},
		templateUrl: function ( tElement, tAttrs ) {
			var defaultUrl = '';
			if ( tAttrs.customTemplate ) {
				return defaultUrl + tAttrs.customTemplate;
			} else {
				return defaultUrl + 'channel-highlight.html';
			}
		},
		controller: 'ChannelHighlightCtrl'
	};
}]);

psrDirectives.directive('navigationFooter', ['$templateCache', function ($templateCache) {
	return {
		restrict: 'E',
		templateUrl: 'navigation-footer.html',
		controller: 'NavigationFooterCtrl'
	};
}]);

psrDirectives.directive('authorHighlight', ['$templateCache', function ($templateCache) {
	return {
		restrict: 'E',
		templateUrl: 'author-highlight.html'
	};
}]);

psrDirectives.directive('eventsHighlight', ['$templateCache', function ($templateCache) {
	return {
		restrict: 'E',
		templateUrl: 'events-highlight.html'
	};
}]);

psrDirectives.directive('psrMegaMenuAba', ['$templateCache', function ($templateCache) {
   return {
     restrict: 'E',
     transclude: true,
	 templateUrl: 'psr-megamenu.html',
	 scope: {
	 	listnav: "="
	 },
	 controller: function($scope, $element){
 		$scope.selected = 0;
	    $scope.setSelected= function(value){
	      $scope.selected=value;
	    };
     }
   };
}]);

psrDirectives.directive('psrTabs', ['$templateCache', function ($templateCache) {
   return {
     restrict: 'E',
     transclude: true,
	 templateUrl: 'psr-tabs.html',
	 scope: {
	 	list: "="
	 },
	 controller: function($scope, $element) {
	 	$scope.selected = 0
	 	$scope.setSelected = function(value){
	      $scope.selected=value;
        };
	 }
   };
}]);

psrDirectives.directive('imageLazySrc', function($document, $window) {
	return {
		restrict: 'AE',
		link: function($scope, $element, $attributes) {
			function isInView() {
				var clientHeight = $document[0].documentElement.clientHeight,
				clientWidth = $document[0].documentElement.clientWidth,
				imageRect = $element[0].getBoundingClientRect();
				if ((imageRect.top >= 0 && imageRect.bottom <= clientHeight) && (imageRect.left >= 0 && imageRect.right <= clientWidth)) {
					$element[0].src = $attributes.imageLazySrc;
					removeEventListeners();
				}
			}

			function removeEventListeners() {
				$window.removeEventListener('scroll', isInView);
				$window.removeEventListener('resize', isInView);
			}

			$window.addEventListener('resize', isInView);
			$window.addEventListener('scroll', isInView);

			$element.on('$destroy', function() {
				removeEventListeners();
			});

			isInView();
		}
	};
});
